import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Badge} from "components";
import {getUserAchievements} from "modules/selectors";
import {useWindowSize} from "modules/utils";
import {
	Container,
	Content,
	ImgContainer,
	Link,
	SubTitle,
	Title,
	TitleContainer,
	Wrapper,
} from "./common";

const sizes: Record<number, number> = {
	0: 171,
	1: 256,
	2: 171,
};

const mobileSize = 157;
const desktopWidth = 1240;
const mobileWidth = 768;

const getSize = (index: number, width: number): string => {
	const isDesktop = width > desktopWidth;
	const isMobile = width <= mobileWidth;

	if (isMobile) {
		return `${mobileSize}px`;
	}

	if (isDesktop) {
		return `${sizes[index]}px`;
	}

	const percent = (width / desktopWidth) * 0.8;
	return `${Math.floor(sizes[index] * percent)}px`;
};

export const LandingBadges: FC = () => {
	const {t} = useTranslation();
	const {width} = useWindowSize();
	const achievements = useSelector(getUserAchievements);
	const isMobile = width <= mobileWidth;
	const length = isMobile ? 1 : 3;
	const filledAchievements = Array.from({length}, (_, i) => achievements[i]);

	return (
		<Wrapper>
			<Container>
				<Content>
					<TitleContainer>
						<SubTitle>{t("main.badges.sub_title")}</SubTitle>
						<Title>{t("main.badges.title")}</Title>
					</TitleContainer>

					<Link to="/badges">{t("main.badges.button")}</Link>
				</Content>

				<ImgContainer>
					{filledAchievements.map((achievement, i) => (
						<Badge
							key={`${i}`}
							achievement={achievement}
							height={getSize(i, width)}
							width={getSize(i, width)}
						/>
					))}
				</ImgContainer>
			</Container>
		</Wrapper>
	);
};
